/**
 * @file: usePrintQuotationForm.ts
 * @copyright: (c) 2019-2021 sichuan zhichetech co., ltd.
 */

import { useSharePdf } from '@euler/functions/sharing/useSharePdf';
import { useServiceFactory } from '@euler/services/factory';
import { useCallback } from 'react';

export const usePrintQuotationForm = (
  orderNo: string,
  options: { type: 'quotation-form' | 'settlement-form'; showPrice?: boolean },
) => {
  const { orderService } = useServiceFactory();
  const name = options.type === 'quotation-form' ? '维修报价单' : '维修结算单';
  const sharePdf = useSharePdf(encodeURIComponent(`${orderNo}-${name}.pdf`));
  return useCallback(async () => {
    const url = await orderService.getRenderQuotationFormAsPdfUrl(
      orderNo,
      options,
    );
    await sharePdf(url);
  }, [options, orderNo, orderService, sharePdf]);
};
